// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'
import 'muse-ui/dist/theme-carbon.css'  //旭日购背景色
import App from './App'
import router from 'PRORouter'
import {post,postImage, postBase, put} from './util/http'
import store from './store'
import XRheadh from './components/index'
import userCache from './util/cache'
import wechatCache from './util/wechatCache'
import baw from './util/baw'
import Es6Promise from 'es6-promise'
Es6Promise.polyfill()
import 'babel-polyfill'
import { isatty } from 'tty';
Vue.prototype.$userCahce = userCache
//require('./util/vconsole.js')  //手机调试时可打开
Vue.use(XRheadh)
Vue.use(MuseUI)


Vue.prototype.BILL_URL = process.env.API_ROOT
Vue.prototype.IMGServer_URL = process.env.IMGServer_URL
Vue.prototype.MOBILE_URL = process.env.MOBILE_URL
Vue.prototype.$post = post;
Vue.prototype.$postImage = postImage;
Vue.prototype.$postBase = postBase;
Vue.prototype.$put = put;
Vue.prototype.ClientType = 2;


Vue.prototype.projectMode = process.env.BRANCH_ENV_MODE //是否是开发版，如果值是test，那就是开发版
Vue.prototype.projectName = process.env.BRANCH_ENV //项目名称
Vue.prototype.themeColor = '71,74,79'  //旭日购背景色
Vue.prototype.candyName = 'BAW'  //糖果的名称
Vue.prototype.candyCname = 'BAW'  //糖果的别名
Vue.prototype.candyDecimal = 2  //糖果的小数位数
Vue.prototype.chainName = 'YSC'  //区块链的名称
Vue.prototype.chainCname = 'YSC'  //区块链的别名
Vue.prototype.chainDecimal = 4  //区块链的小数位数
//Vue.prototype.closeCoupon = true  //是否关闭优惠券模块
Vue.prototype.isCoinTransfer = true  //是否开放金豆转账功能


let user = userCache.getUser()
if(typeof user == 'string' && user){
  //alert(user)
  store.dispatch('SetUser', user)
}
let openId = wechatCache.getOpenId()
if(typeof openId == 'string'){
  store.dispatch('SETWeChat', openId)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App, XRheadh },
  template: '<App/>'
})

router.beforeEach((to, from, next) => {
  var isAuth = to.matched.some(record => record.meta.requireAuth)
  var appClient = window.localStorage.appClient  
  if(appClient == 'android' || appClient == 'ios'){
    var isAppAuth = to.matched.some(record => record.meta.appRequireAuth)
    if(isAppAuth){
      isAuth =isAppAuth
    }
  }
  if (isAuth) { // 判断该路由是否需要登录权限
    var userInfo = userCache.getUser()
    var token = store.state.user.SessionId
    if (token && userInfo) { // 判断当前的token是否存在
      next();
    }
    else {
      userCache.delUser()
      store.dispatch('DelUser')
      /*指定页跳转到上一页功能可在此设置 */
      var gotoUrl = '/login'
      var queryJson
	  console.log(to)
	  var msg = to.matched.some(record => record.meta.msg)
	  if (msg){
		queryJson = { redirect: to.fullPath,msg: to.meta.msg}
	  } else {
		queryJson = { redirect: to.fullPath,isLose: 1}
	  }
      var bawToken = store.state.baw.LoginToken
      if(bawToken){
        gotoUrl = '/bawlogin'
        queryJson.token = bawToken
        queryJson.autoredirect = true
      }
      next({
        path: gotoUrl,
        query: queryJson // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else {
    next();
  }
});
router.afterEach((to, from, next)=>{
  // setTimeout(()=>{
  //   var _hmt = _hmt || [];
  //   (function(m, ei, q, i, a, j, s) {
  //     m[i] = m[i] || function() {
  //         (m[i].a = m[i].a || []).push(arguments)
  //     };
  //     j = ei.createElement(q),
  //         s = ei.getElementsByTagName(q)[0];
  //     j.async = true;
  //     j.charset = 'UTF-8';
  //     j.src = 'https://static.meiqia.com/dist/meiqia.js?_=t';
  //     s.parentNode.insertBefore(j, s);
  //   })(window, document, 'script', '_MEIQIA');
  //   _MEIQIA('entId', 115010);
  // },0);
});



// WEBPACK FOOTER //
// ./src/main.xurigo.js